export default "__VITE_ASSET__BIf5K$57__"